export const getSafeNumber = (value: any) => {
    if (value === '' || value == null) return null;
    const parsedValue = Number(value);
    return isNaN(parsedValue) ? null : parsedValue;
}